import { Fragment, useCallback } from 'react';

import { useFormContext } from 'react-hook-form';
import { MultiValue } from 'react-select';

import { Divider, IconButton } from '@hsp/react-component-library';

import { VirtualSelect } from 'components/select';
import { useFetchOmitFlags } from 'pages/audience/shared/hooks/queries';
import { IOmitFlag, ISelectedFilter } from 'types/api/audience';
import { SearchType } from 'types/api/audience/enums';
import { s } from 'utilities/strings';

const formName = SearchType.Omits;

const OmitFlags = () => {
  const { data: flags, isFetching } = useFetchOmitFlags();
  const { getValues, setValue } = useFormContext();
  const getValue = useCallback(() => {
    const current = getValues(formName) as ISelectedFilter<IOmitFlag>;

    return current;
  }, [getValues]);

  const getFlagValue = useCallback(() => {
    const current = getValue();

    return (flags ?? []).filter((flag) =>
      (current?.filters ?? []).find((selected) => flag.id.toString() === selected.id.toString())
    );
  }, [flags, getValue]);

  const handleOnOmitChanged = useCallback(
    (omits: MultiValue<IOmitFlag>) => {
      const current = getValue();

      setValue(formName, { ...current, filters: omits });
    },
    [getValue, setValue]
  );

  return (
    <Fragment>
      <div className="mb-3">
        <Divider>{s(['Site.Pages.AudienceBuilder.Create.Omit', 'Site.Flag'], { plural: true })}</Divider>
      </div>
      <div className="d-flex">
        <VirtualSelect
          className="flex-grow-1"
          closeMenuOnSelect={false}
          getOptionLabel={({ name }) => name}
          getOptionValue={({ id }) => id.toString()}
          isClearable
          isDisabled={isFetching}
          isLoading={isFetching}
          isMulti
          onChange={handleOnOmitChanged}
          options={flags}
          placeholder={s(['Site.Select', 'Site.Pages.AudienceBuilder.Create.Omit', 'Site.Flag'], { plural: true })}
          value={getFlagValue()}
        />
        <IconButton
          className="ms-3 flex-shrink-0 align-self-start"
          color="primary"
          icon={['fas', 'check']}
          onClick={() => {
            handleOnOmitChanged(flags as MultiValue<IOmitFlag>);
          }}>
          {s(['Site.Select', 'Site.All'])}
        </IconButton>
      </div>
    </Fragment>
  );
};

export default OmitFlags;
